import React from 'react'
import { BarChart, Bar, XAxis, YAxis, LabelList, ResponsiveContainer, Legend } from 'recharts';
import {cleanTitle, cleanHtml} from './AqUtilities';

export default function AqBoolean({ question, data }) {

    data.title = cleanHtml(question.title);
    data.total = data.true + data.false;
    const colors = ["#FF5A64", "#7AC36A"]
    const shapedData = question.itemizedChoices.map((m,index)=>{
        return {title:m.text, value:data[m.value], fill: colors[index] }});

    console.log(shapedData);

    return (
        <div className="aq-boolean">

            <h5>{cleanTitle(question.title)}</h5>            

            <ResponsiveContainer width="80%" height={70}> 
            <BarChart  data={shapedData} layout="vertical">                
                <XAxis type="number" hide axisLine={false} padding={{ right: 40 }} />
                <YAxis type="category" dataKey="title" tickLine={false} axisLine={false} width={250} />

                <Bar dataKey="value" isAnimationActive={false}>
                    <LabelList dataKey="value" position="right" style={{ fill: "black" }} />
                </Bar>                
            </BarChart>
            </ResponsiveContainer> 


            <div id="aq-bar-total">Total = <span id="aq-bar-total-number">{data.total}</span></div>

        </div>
    )
}